import logo from "../images/Logo.png"
import {
    FaFacebook,
    FaTwitter,
    FaInstagram,
    FaLinkedinIn,
    FaHome,
    FaInfoCircle,
    FaWrench,
    FaPhoneAlt,
} from 'react-icons/fa';
import { FaLinkedin } from "react-icons/fa6";
import { RxCross2 } from 'react-icons/rx';

const Footer = (props) => {
    const color = props.color;
    return (
        <div>
            <footer className="background-with-image-blue text-white py-6 md:py-12 hidden md:block">
                <div className="mx-auto px-16 md:flex justify-start space-y-12 md:space-y-0 md:space-x-24">
                    {/* Logo and Social Icons */}
                    <div className="flex flex-col items-start md:items-center">
                        <div className="text-center">
                            <img
                                src={logo}
                                alt="Logo"
                                className="w-[120px] mb-4 object-contain"
                            />
                        </div>

                        <div className="flex space-x-6 text-xl mt-0">
                            <a href="#" aria-label="Facebook" className="hover:text-gray-300">
                                <FaFacebook />
                            </a>
                            <a href="#" aria-label="Instagram" className="hover:text-gray-300">
                                <FaInstagram />
                            </a>
                            <a href="#" aria-label="LinkedIn" className="hover:text-gray-300">
                                <FaLinkedin />
                            </a>
                        </div>
                    </div>

                    {/* Navigation Links */}
                    <div className="poppins text-sm pt-4">
                        {/* Site Map */}
                        <div>
                            <ul className="space-y-4">
                                <li className="flex items-start md:items-center space-x-3 hover:text-gray-300 cursor-pointer">
                                    {/* <FaHome /> */}
                                    <a href="/">HOME</a>
                                </li>
                                <li className="flex items-center space-x-3 hover:text-gray-300 cursor-pointer">
                                    {/* <FaInfoCircle /> */}
                                    <a href="/About">ABOUT</a>
                                </li>
                                <li className="flex items-center space-x-3 hover:text-gray-300 cursor-pointer">
                                    {/* <FaWrench /> */}
                                    <a href="/Services">VIP SERVICES</a>
                                </li>
                                <li className="flex items-center space-x-3 hover:text-gray-300 cursor-pointer">
                                    {/* <FaPhoneAlt /> */}
                                    <a href="/Contact">CONTACT US</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </footer>
            <footer className={`text-${color == "blue" ? "white" : "[#80a2a5]"} py-6 md:py-12 ${color == "blue" ? "background-with-image-blue" : "bg-[#edebe6]"} block md:hidden fixed bottom-0 left-0 w-full z-50`}>
                <div className="grid grid-cols-3 px-4 ">
                    <div className="text-center hover:text-gray-300 cursor-pointer">
                        <a href="/Services" className={`text-md transition delay-50 duration-300 ease-in-out  pb-2 border-transparent border-b-2 font-normal poppins `}>
                            VIP SERVICES
                        </a>
                    </div>
                    <div className="text-center  hover:text-gray-300 cursor-pointer">
                        <a href="/About" className={`text-md transition delay-50 duration-300 ease-in-out   pb-2 border-transparent border-b-2  font-normal poppins `}>
                            ABOUT
                        </a>
                    </div>
                    <div className="text-center  hover:text-gray-300 cursor-pointer">
                        <a href="/Contact" className={`text-md transition delay-50 duration-300 ease-in-out   pb-2 border-transparent border-b-2 font-normal poppins `}>
                            CONTACT US
                        </a>
                    </div>
                </div>

                <div className="text-center hover:text-gray-300 cursor-pointer mt-6">
                    <a href="/Rewire" className={`uppercase px-4 rounded-full text-md transition delay-50 duration-300 ease-in-out text-white  py-1  border-2 border-[#f15d16] bg-[#f15d16] font-normal mb-2 poppins `}>
                        rewire now
                    </a>
                </div>
            </footer>
        </div> 
    );
};

export default Footer;
